import React from 'react';
import './ApexPricing.css';
import { FaDiscord } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import ApexPricingBoxes from './ApexPricing_Boxes';
import paypalImg from '../rust/assets/paypal.png';
import visaImg from '../rust/assets/visa.png';
import mastercardImg from '../rust/assets/mastercard.png';
import alipayImg from '../rust/assets/alipay.png';
import bitcoinImg from '../rust/assets/bitcoin.png';
import etherImg from '../rust/assets/ether.png';
import skinsImg from '../rust/assets/skins.png';
import giftcardsImg from '../rust/assets/giftcards.png';
import tetherImg from '../rust/assets/tether.png';
import webmoneyImg from '../rust/assets/webmoney.png';
import unionpayImg from '../rust/assets/unionpay.png';

const ApexPricing = () => {
  const { t } = useTranslation();

  return (
    <div className="apex-pricing-component" id="pricing">
      {/* Neuer Header-Bereich */}
      <div className="apex-pricing-header">
        <h2>{t('pricing_heading')}</h2>
        <p className="apex-pricing-header-text">{t('pricing_header_text')}</p>
      </div>

      {/* Pricing Boxes direkt ohne Tabs */}
      <ApexPricingBoxes />

      {/* Combined container for Payment Grids and Discord */}
      <div className="apex-pricing-additional-wrapper">
        <div className="apex-additional-box apex-payment-methods-box">
          <span className="apex-payment-label">{t('pay_with')}</span>
          <div className="apex-pricing-payment-grid">
            {[paypalImg, visaImg, mastercardImg, alipayImg, bitcoinImg, etherImg].map((src,i) => (
              <div key={i} className="apex-grid-item">
                <img src={src} alt={`Payment option ${i + 1}`} loading="lazy" />
              </div>
            ))}
          </div>
          <div className="apex-pricing-payment-grid second">
            {[skinsImg, giftcardsImg, tetherImg, webmoneyImg, unionpayImg].map((src,i) => (
              <div key={i} className="apex-grid-item">
                <img src={src} alt={`Additional payment method ${i + 1}`} loading="lazy" />
              </div>
            ))}
          </div>
        </div>
        <div className="apex-additional-box apex-discord-box">
          <span className="apex-support-label">{t('need_support')}</span>
          <button className="apex-pricing-discord-button" onClick={() => window.open('https://discord.com/invite/zEeq3jTzAR', '_blank')}>
            <FaDiscord />
            <span>{t('discord')}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApexPricing;